import React from 'react';
import BackToTop from '@bibliocommons/base-back-to-top';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import { DataLayerContainer } from 'app/components/analytics/DataLayer';
import CoreHeaderContainer from 'app/components/layouts/CoreHeader/CoreHeaderContainer';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import { ErrorBoundaryContainer } from 'app/components/errors/ErrorBoundary';
import FooterContainer from 'app/components/deprecated/Footer/FooterContainer';
import GlobalProgressBarContainer from 'app/components/layouts/GlobalProgressBar/GlobalProgressBarContainer';
import { GlobalMessagingContainer } from 'app/components/GlobalMessaging';
import StaffTakeoverMessageContainer from 'app/components/shared/StaffTakeoverMessage/StaffTakeoverMessageContainer';
import ScreenReaderShortcutsContainer from 'app/components/shared/ScreenReaderShortcuts/ScreenReaderShortcutsContainer';
import { SystemMessagesContainer } from 'app/components/shared/SystemMessages';
import { LoginModalContainer } from 'app/components/login/LoginModal';
import PrivacySettingsModalContainer from 'app/components/bibs/shared/ugc/PrivacySettingsModal';
import IEDiscontinuedMessage from 'app/components/shared/IEDiscontinuedMessage';
import Context from '@bibliocommons/context';

import './styles/MainLayout.scss';
import './styles/migration.scss';

export class MainLayout extends React.PureComponent {
  render() {
    return (
      <div>
        <IEDiscontinuedMessage />
        <DataLayerContainer />
        <DocumentHeadContainer />
        {!this.context.mobileApp && <ScreenReaderShortcutsContainer />}
        <GlobalProgressBarContainer />
        <StaffTakeoverMessageContainer />
        <CoreHeaderContainer />
        <div id="preview-bar" />
        <SystemMessagesContainer />
        <section id="content" tabIndex="-1">
          <ErrorBoundaryContainer>{this.props.children}</ErrorBoundaryContainer>
        </section>
        <GlobalMessagingContainer />
        <LoginModalContainer />
        <FooterContainer />
        {!this.context.mobileApp && <BackToTop />}
        <PrivacySettingsModalContainer />
      </div>
    );
  }
}

MainLayout.propTypes = {
  children: childrenShape.isRequired
};

MainLayout.contextType = Context;

export default MainLayout;
